import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, withCtx as _withCtx, createVNode as _createVNode, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "d-flex align-items-center"
};
const _hoisted_2 = {
  class: "flex-shrink-0 d-flex align-items-center"
};
const _hoisted_3 = ["innerHTML"];
const _hoisted_4 = {
  key: 1,
  class: "vue-notification-template vue-notification success min-width-340"
};
const _hoisted_5 = {
  class: "d-flex align-items-center"
};
const _hoisted_6 = {
  class: "flex-shrink-0 d-flex align-items-center"
};
const _hoisted_7 = ["innerHTML"];
const _hoisted_8 = {
  class: "d-flex align-items-center"
};
const _hoisted_9 = {
  class: "flex-shrink-0"
};
const _hoisted_10 = ["innerHTML"];
const _hoisted_11 = ["onClick"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_b_spinner = _resolveComponent("b-spinner");
  const _component_mc_ico_success = _resolveComponent("mc-ico-success");
  const _component_mc_ico_warning = _resolveComponent("mc-ico-warning");
  const _component_notifications = _resolveComponent("notifications");
  return _openBlock(), _createElementBlock(_Fragment, null, [_createVNode(_component_notifications, {
    position: "bottom left",
    width: "322px "
  }, {
    body: _withCtx(props => [(props.item.type === 'success' || props.item.type === 'warn' || props.item.type === 'error') && props.item.loading != true ? (_openBlock(), _createElementBlock("div", {
      key: 0,
      class: _normalizeClass(["vue-notification-template vue-notification success min-width-340", props.item.type === 'success' ? 'success' : props.item.type === 'warn' ? 'warn' : 'error'])
    }, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [props.item.type === 'loading' ? (_openBlock(), _createBlock(_component_b_spinner, {
      key: 0,
      variant: "success",
      small: "",
      style: {
        "width": "24px",
        "height": "24px"
      }
    })) : _createCommentVNode("", true), props.item.type === 'success' ? (_openBlock(), _createBlock(_component_mc_ico_success, {
      key: 1,
      size: "24",
      fill: "#16DB93"
    })) : _createCommentVNode("", true), props.item.type === 'warn' || props.item.type === 'error' ? (_openBlock(), _createBlock(_component_mc_ico_warning, {
      key: 2,
      size: "24",
      fill: props.item.type === 'warn' ? '#9D8223' : '#ffffff'
    }, null, 8, ["fill"])) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: "flex-grow-1 ms-3",
      innerHTML: props.item.text
    }, null, 8, _hoisted_3)])], 2)) : (_openBlock(), _createElementBlock("div", _hoisted_4, [_createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [props.item.type === 'loading' ? (_openBlock(), _createBlock(_component_b_spinner, {
      key: 0,
      variant: "success",
      small: "",
      style: {
        "width": "24px",
        "height": "24px"
      }
    })) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: "flex-grow-1 ms-3",
      innerHTML: props.item.text
    }, null, 8, _hoisted_7)])]))]),
    _: 1
  }), _createVNode(_component_notifications, {
    group: "action",
    position: "bottom left",
    width: "379px"
  }, {
    body: _withCtx(props => [_createElementVNode("div", {
      class: _normalizeClass(["vue-notification-template vue-notification success", props.item.type === 'success' || props.item.type === 'loading' ? 'success' : props.item.type === 'warn' ? 'warn' : 'error'])
    }, [_createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [props.item.type === 'success' ? (_openBlock(), _createBlock(_component_mc_ico_success, {
      key: 0,
      size: "24",
      fill: "#16DB93"
    })) : _createCommentVNode("", true), props.item.type === 'warn' || props.item.type === 'error' ? (_openBlock(), _createBlock(_component_mc_ico_warning, {
      key: 1,
      size: "24",
      fill: props.item.type === 'warn' ? '#9D8223' : '#ffffff'
    }, null, 8, ["fill"])) : _createCommentVNode("", true)]), _createElementVNode("div", {
      class: "flex-grow-1 ms-3",
      innerHTML: props.item.text
    }, null, 8, _hoisted_10), _createElementVNode("div", null, [_createElementVNode("a", {
      href: "javascript:void(0)",
      class: "text-reset",
      onClick: $event => $options.close(props.item.id)
    }, "Show", 8, _hoisted_11)])])], 2)]),
    _: 1
  })], 64);
}